import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-3cfbf92f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_0,
  alt: "logo"
}, null, -1))
const _hoisted_3 = { class: "header-nav-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headerNavList, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["header-nav-item", _ctx.active === item.active ? 'active' : '']),
          key: index
        }, [
          _createVNode(_component_router_link, {
            to: item.navPath
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.navName), 1)
            ]),
            _: 2
          }, 1032, ["to"])
        ], 2))
      }), 128))
    ])
  ]))
}